import { render, staticRenderFns } from "./real-success.vue?vue&type=template&id=5b1497a0&scoped=true"
import script from "./real-success.vue?vue&type=script&lang=js"
export * from "./real-success.vue?vue&type=script&lang=js"
import style0 from "./real-success.vue?vue&type=style&index=0&id=5b1497a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1497a0",
  null
  
)

export default component.exports